import React from 'react'
import { Link } from 'react-router-dom'
import Tag from '../assets/price-tag-outline.svg?svgr-webpack'
import StopWatch from '../assets/stopwatch.svg?svgr-webpack'
import Calendar from '../assets/calendar.svg?svgr-webpack'
import { FormattedDate } from 'react-intl'

import { NutritionArticle_nutritionArticle_categories } from '../queries/types/NutritionArticle'

type CategoryProps = {
  slug: string
  name: string
  inList?: boolean
}

const Category = ({ slug, name, inList = false }: CategoryProps) => {
  const link = (
    <Link
      to={`/nutrition-explained/category/${slug}`}
      className={`
      hover:border-Type, inline-block
      truncate border-b-1
      border-grey-lightest text-Type transition
    `}
      style={{
        maxWidth: 'min(30vw, 150px)',
      }}
    >
      {name}
    </Link>
  )

  if (!inList) return link

  return <li className="pt-8 first:pt-0 md:pt-0">{link}</li>
}

type ListItemProps = {
  icon: React.ComponentType<{ className?: string; style?: React.CSSProperties }>
  children: React.ReactNode
}

const ListItem = ({ icon: Icon, children }: ListItemProps) => {
  return (
    <li
      className={`
      flex flex-col items-center md:mx-24 lg:mx-0
      lg:my-20 lg:flex-row lg:items-start
    `}
    >
      <Icon
        className={`
          relative
          -mt-2 mb-6
          h-16 w-16 text-Type lg:mb-0
          lg:mr-12 lg:h-24 lg:w-24 lg:text-green
        `}
        style={{ bottom: 1 }}
      />
      {children}
    </li>
  )
}

type Props = {
  publishDate: string
  categories: NutritionArticle_nutritionArticle_categories[]
  readingTime: number
}

export default function ArticleMeta({
  publishDate,
  categories,
  readingTime,
}: Props) {
  return (
    <ul
      className={`
      type-upper relative mx-auto
      mt-20 flex w-full
      justify-between text-center leading-default sm:justify-evenly md:mb-24
      md:justify-center lg:m-auto
      lg:mt-30 lg:block
      lg:w-auto lg:text-left
    `}
    >
      {publishDate && (
        <ListItem icon={Calendar}>
          <span className="sr-only">Published: </span>
          <FormattedDate value={publishDate} />
        </ListItem>
      )}
      {categories.length > 0 && (
        <ListItem icon={Tag}>
          <span className="sr-only">Categories: </span>
          {categories.length === 1 ? (
            <Category
              slug={categories[0].slug as string}
              name={categories[0].name as string}
            />
          ) : (
            <ul>
              {categories.slice(0, 2).map(({ name, slug, id }) => (
                <Category
                  inList
                  key={id}
                  slug={slug as string}
                  name={name as string}
                />
              ))}
            </ul>
          )}
        </ListItem>
      )}
      {readingTime && (
        <ListItem icon={StopWatch}>{readingTime} min. read</ListItem>
      )}
    </ul>
  )
}
